import React, { useState, useEffect } from 'react';
import '../App.css';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import MyLoader from './util/loader';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Guides = () => {
    const [guides, setGuides] = useState([])
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        console.log('load data');
        setLoader(true)
        Api.getGuides(
            (response) => {
                setLoader(false)
                let guides = JSON.parse(response.data)
                console.log('guides: '+guides);
                setGuides(guides)
            },
            (error) => {
                setLoader(false)
            });
    };

    const updateGuides = () => {
        setLoader(true)
        Api.updateGuides(JSON.stringify(guides),
            (response) => {
                setLoader(false)
                showToast('success', 'Guides Updated!')
            },
            (error) => {
                setLoader(false)
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Guides
                </div>
            </div>
            <div style={{ marginTop: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Form className="form" style={{ width: 600, marginTop:20, backgroundColor:'#f2f2f2' }}>

                    {guides.map((item, index) => {
                        return (
                            <div style={{ marginTop: 10, width: '100%' }}>
                                <div>{item.id}</div>
                                <FormGroup>
                                    <Input
                                        type='textarea'
                                        placeholder=''
                                        value={item.detail}
                                        onChange={(event) => {
                                            console.log('change: ' + event.target.value);
                                            const temp = guides.map((item_) => {
                                                if (item_.id + '' === item.id + '') {
                                                    return {
                                                        id: item.id,
                                                        detail: event.target.value
                                                    };
                                                }
                                                else {
                                                    return item_;
                                                }
                                            });
                                            setGuides(temp)
                                        }} />
                                </FormGroup>
                            </div>
                        )
                    })}

                    <Button
                        style={{ marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            updateGuides()
                        }}>
                        Update Guides
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default Guides;
